import React from 'react';
import { AlertCircle, Users, Luggage } from 'lucide-react';
import { Button } from '../ui/button';

const NoVehiclesAvailable = ({ passengerCount, luggageCount, onEditPassengers, onEditLuggage }) => {
  return (
    <div className="bg-white rounded-xl p-8 text-center" data-testid="no-vehicles-message">
      <div className="w-16 h-16 bg-[#FF8C00]/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <AlertCircle className="h-8 w-8 text-[#FF8C00]" />
      </div>
      
      <h3 className="text-xl font-bold text-black mb-2">
        No vehicles available
      </h3>
      <p className="text-gray-500 mb-6">
        for {passengerCount} passengers and {luggageCount} luggage items
      </p>

      <p className="text-sm text-gray-400 mb-6">
        Our largest vehicle can accommodate up to 50 passengers and 40 luggage items.
        Please adjust your selection or consider multiple bookings.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          data-testid="edit-passengers-btn"
          className="bg-[#FF8C00] text-white hover:bg-[#E67E00]"
          onClick={onEditPassengers}
        >
          <Users className="h-4 w-4 mr-2" />
          Edit Passengers
        </Button>
        <Button
          data-testid="edit-luggage-btn"
          variant="outline"
          className="border-[#FF8C00] text-[#FF8C00] hover:bg-[#FF8C00]/10"
          onClick={onEditLuggage}
        >
          <Luggage className="h-4 w-4 mr-2" />
          Edit Luggage
        </Button>
      </div>
    </div>
  );
};

export default NoVehiclesAvailable;
